<div class="fixed inset-0 z-10 bg-neutral-950 mix-blend-multiply flex items-center justify-center">
	<div class="w-[22rem] h-[32rem] flex-none pt-12 border border-white bg-black text-white flex flex-col gap-4">

		<app-ui-logo></app-ui-logo>

		<div class="font-decimaLight uppercase text-base leading-none flex justify-center">&nbsp;&nbsp;&nbsp;L&nbsp;&nbsp;&nbsp;O&nbsp;&nbsp;&nbsp;G&nbsp;&nbsp;&nbsp;R&nbsp;&nbsp;&nbsp;</div>


		<div class="w-full flex-1">
			<ng-content></ng-content>
		</div>


	</div>

</div>
<div class="video-layer">
	<video src="/videos/bg-02.mov" autoplay class="background-video" loop muted playsinline></video>
</div>